<template>
  <b-card>
    <b-form
      novalidate
      @submit.prevent="submit"
    >
      <validation-observer ref="formRef">
        <b-row>
          <b-col md="6">
            <validation-provider
              #default="{ errors }"
              name="Screen Name"
              rules="required"
            >
              <b-form-group
                label="Screen Name"
                label-for="screen-name"
              >
                <b-form-input
                  id="screen-name"
                  v-model="formData.screen"
                  placeholder="Enter Screen Name"
                />
                <span class="text-danger"> {{ errors[0] }} </span>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col
            md="6"
            class="d-flex justify-content-end align-items-center"
          >
            <b-button
              style="margin-top:20px"
              variant="primary"
              type="submit"
              :disabled="submitting || filesUploading"
            >
              <b-spinner
                v-if="submitting"
                small
              />
              <span v-else>Save</span>
            </b-button>
          </b-col>
          <b-col md="12">
            <div class="d-flex align-items-center justify-content-between">
              <h3>Primary</h3>
              <b-button
                class="mb-1"
                variant="primary"
                @click="pushNewPrimaryHero"
              >
                New primary hero
              </b-button>
            </div>
            <validation-observer ref="primaryRef">
              <b-row
                v-for="(primaryHero, ix) in formData.items.primary"
                :key="`primary-${ix}`"
                class="p-1 m-1"
                style="border: 1px solid #4B6C95; border-radius:15px"
              >
                <b-col md="4">
                  <validation-provider
                    #default="{ errors }"
                    name="Image"
                    :rules="primaryHero.image ? '' : 'required'"
                  >
                    <b-form-group
                      label="Image"
                      :label-for="`primary-hero-file-${primaryHero.localId}`"
                    >
                      <div class="d-flex">
                        <b-form-file
                          :id="`primary-hero-file-${primaryHero.localId}`"
                          v-model="primaryHero.file"
                          placeholder="Enter Image"
                          @input="fileInputHandler($event, primaryHero)"
                        />
                        <b-spinner
                          v-if="primaryHero.uploadingFile"
                          variant="primary"
                          small
                          style="margin: auto 0"
                        />
                        <b-avatar
                          v-if="primaryHero.image"
                          size="md"
                          :src="primaryHero.image"
                        />
                      </div>

                      <span class="text-danger"> {{ errors[0] }} </span>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col md="4">
                  <validation-provider
                    #default="{ errors }"
                    name="Title"
                    rules="required"
                  >
                    <b-form-group
                      label="Title"
                      :label-for="`primary-hero-title-${primaryHero.localId}`"
                    >
                      <b-form-input
                        :id="`primary-hero-title-${primaryHero.localId}`"
                        v-model="primaryHero.title"
                        placeholder="Enter Title"
                      />
                      <span class="text-danger"> {{ errors[0] }} </span>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col md="4">
                  <validation-provider
                    #default="{ errors }"
                    name="Address"
                    rules="required"
                  >
                    <b-form-group
                      label="Address"
                      :label-for="`primary-hero-address-${primaryHero.localId}`"
                    >
                      <b-form-input
                        :id="`primary-hero-address-${primaryHero.localId}`"
                        v-model="primaryHero.address"
                        placeholder="Enter Address"
                      />
                      <span class="text-danger"> {{ errors[0] }} </span>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col md="4">
                  <validation-provider
                    #default="{ errors }"
                    name="Description"
                    rules="required"
                  >
                    <b-form-group
                      label="Description"
                      :label-for="`primary-hero-description-${primaryHero.localId}`"
                    >
                      <b-form-textarea
                        :id="`primary-hero-description-${primaryHero.localId}`"
                        v-model="primaryHero.description"
                        placeholder="Enter Description"
                      />
                      <span class="text-danger"> {{ errors[0] }} </span>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col md="4">
                  <validation-provider
                    #default="{ errors }"
                    name="Action"
                    rules="required"
                  >
                    <b-form-group
                      label="Action"
                      :label-for="`primary-hero-action-${primaryHero.localId}`"
                    >
                      <b-form-input
                        :id="`primary-hero-action-${primaryHero.localId}`"
                        v-model="primaryHero.action"
                        placeholder="Enter Action"
                      />
                      <span class="text-danger"> {{ errors[0] }} </span>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col md="4">
                  <b-button
                    v-if="formData.items.primary.length > 1"
                    style="margin-top:21px"
                    variant="danger"
                    block
                    @click="removePrimaryHero(ix)"
                  >
                    Remove Row
                  </b-button>
                </b-col>
              </b-row>
            </validation-observer>
          </b-col>
          <b-col md="12">
            <div class="d-flex align-items-center justify-content-between">
              <h3>Secondary</h3>
              <b-button
                class="mb-1"
                variant="primary"
                @click="pushNewSecondaryHero"
              >
                New secondary hero
              </b-button>
            </div>
            <validation-observer ref="secondaryRef">
              <b-row
                v-for="(secondaryHero, ix) in formData.items.secondary"
                :key="`secondary-${ix}`"
                class="p-1 m-1"
                style="border: 1px solid #4B6C95; border-radius:15px"
              >
                <b-col md="4">
                  <validation-provider
                    #default="{ errors }"
                    name="Image"
                    :rules="secondaryHero.image ? '' : 'required'"
                  >
                    <b-form-group
                      label="Image"
                      :label-for="`secondary-hero-file-${secondaryHero.localId}`"
                    >
                      <div class="d-flex">
                        <b-form-file
                          :id="`secondary-hero-file-${secondaryHero.localId}`"
                          v-model="secondaryHero.file"
                          placeholder="Enter Image"
                          @input="fileInputHandler($event, secondaryHero)"
                        />
                        <b-spinner
                          v-if="secondaryHero.uploadingFile"
                          variant="primary"
                          small
                          style="margin: auto 0"
                        />
                        <b-avatar
                          v-if="secondaryHero.image"
                          size="md"
                          :src="secondaryHero.image"
                        />

                      </div>

                      <span class="text-danger"> {{ errors[0] }} </span>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col md="4">
                  <validation-provider
                    #default="{ errors }"
                    name="Title"
                    rules="required"
                  >
                    <b-form-group
                      label="Title"
                      :label-for="`secondary-hero-title-${secondaryHero.localId}`"
                    >
                      <b-form-input
                        :id="`secondary-hero-title-${secondaryHero.localId}`"
                        v-model="secondaryHero.title"
                        placeholder="Enter Title"
                      />
                      <span class="text-danger"> {{ errors[0] }} </span>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col md="4">
                  <validation-provider
                    #default="{ errors }"
                    name="Address"
                    rules="required"
                  >
                    <b-form-group
                      label="Address"
                      :label-for="`secondary-hero-address-${secondaryHero.localId}`"
                    >
                      <b-form-input
                        :id="`secondary-hero-address-${secondaryHero.localId}`"
                        v-model="secondaryHero.address"
                        placeholder="Enter Address"
                      />
                      <span class="text-danger"> {{ errors[0] }} </span>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col md="4">
                  <validation-provider
                    #default="{ errors }"
                    name="Description"
                    rules="required"
                  >
                    <b-form-group
                      label="Description"
                      :label-for="`secondary-hero-description-${secondaryHero.localId}`"
                    >
                      <b-form-textarea
                        :id="`secondary-hero-description-${secondaryHero.localId}`"
                        v-model="secondaryHero.description"
                        placeholder="Enter Description"
                      />
                      <span class="text-danger"> {{ errors[0] }} </span>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col md="4">
                  <validation-provider
                    #default="{ errors }"
                    name="Action"
                    rules="required"
                  >
                    <b-form-group
                      label="Action"
                      :label-for="`secondary-hero-action-${secondaryHero.localId}`"
                    >
                      <b-form-input
                        :id="`secondary-hero-action-${secondaryHero.localId}`"
                        v-model="secondaryHero.action"
                        placeholder="Enter Action"
                      />
                      <span class="text-danger"> {{ errors[0] }} </span>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col md="4">
                  <b-button
                    v-if="formData.items.secondary.length > 1"
                    style="margin-top:21px"
                    variant="danger"
                    block
                    @click="removeSecondaryHero(ix)"
                  >
                    Remove Row
                  </b-button>
                </b-col>
              </b-row>
            </validation-observer>
          </b-col>
        </b-row>
      </validation-observer>
    </b-form>
  </b-card>
</template>

<script>
import {
  BRow, BCol, BCard, BFormGroup, BFormInput, BForm, BButton, BFormFile, BFormTextarea, BSpinner, BAvatar,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import { computed, ref } from '@vue/composition-api'
import axios from 'axios'
import axiosIns from '@/libs/axios'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import store from '../../store'

export default {
  components: {
    BRow,
    BCol,
    BSpinner,
    BCard,
    ValidationProvider,
    BAvatar,
    ValidationObserver,
    BFormGroup,
    BFormTextarea,
    BFormInput,
    BFormFile,
    BForm,
    BButton,
  },
  props: {
    isNew: {
      type: Boolean,
      default: true,
    },
  },
  setup(_, ctx) {
    const heroId = ctx.root.$route.params.id
    useRegisterStoreModule('business', store)

    const generateHeroObject = () => ({
      image: null,
      title: '',
      description: '',
      address: '',
      action: '',
      localId: Math.random().toString(),
      uploadingFile: false,
      file: null,
    })
    const formData = ref({
      screen: '',
      items: {
        primary: [{ ...generateHeroObject() }],
        secondary: [{ ...generateHeroObject() }],
      },
    })

    const pushNewPrimaryHero = () => formData.value.items.primary.unshift({ ...generateHeroObject() })
    const pushNewSecondaryHero = () => formData.value.items.secondary.unshift({ ...generateHeroObject() })
    const removePrimaryHero = ix => formData.value.items.primary.splice(ix, 1)
    const removeSecondaryHero = ix => formData.value.items.secondary.splice(ix, 1)

    const fileInputHandler = async (file, heroObj) => {
      if (!file) return
      try {
        // eslint-disable-next-line no-param-reassign
        heroObj.uploadingFile = true
        const preSignedRes = await axiosIns.get('/signed-urls', {
          params: {
            fileName: file.name,
            isPublic: true,
          },
        })
        const { url } = preSignedRes.data.data
        await axios.put(url, file, {
          headers: {
            'Content-Type': file.type,
          },
        })
        const imageUrl = new URL(url)
        const image = imageUrl.origin + imageUrl.pathname
        // eslint-disable-next-line no-param-reassign
        heroObj.image = image
      } catch (err) {
        console.log(err)
        // eslint-disable-next-line no-param-reassign
        heroObj.image = null
        // eslint-disable-next-line no-param-reassign
        heroObj.file = null
      } finally {
        // eslint-disable-next-line no-param-reassign
        heroObj.uploadingFile = false
      }
    }

    const filesUploading = computed(() => {
      const primaryLoadings = formData.value.items.primary.some(item => item.uploadingFile)
      const secondaryLoadings = formData.value.items.secondary.some(item => item.uploadingFile)
      return primaryLoadings || secondaryLoadings
    })
    const formRef = ref(null)
    const primaryRef = ref(null)
    const secondaryRef = ref(null)
    const submitting = ref(false)
    const submit = async () => {
      const result = await primaryRef.value.validate()
      const secResult = await secondaryRef.value.validate()
      const res = await formRef.value.validate()
      if (!res || !result || !secResult) return
      submitting.value = true
      try {
        await ctx.root.$store.dispatch('business/createHeros', {
          screen: formData.value.screen,
          items: {
            primary: formData.value.items.primary.map(el => ({
              image: el.image,
              title: el.title,
              description: el.description,
              address: el.address,
              action: el.action,
            })),
            secondary: formData.value.items.secondary.map(el => ({
              image: el.image,
              title: el.title,
              description: el.description,
              address: el.address,
              action: el.action,
            })),
          },
        })
        ctx.root.$router.push('/businesses/heros')
      } finally {
        submitting.value = false
      }
    }

    const fetchHeroById = async () => {
      const res = await ctx.root.$store.dispatch('business/getHero', heroId)
      const heroTemp = res.data.data[0]
      formData.value.screen = heroTemp.screen
      formData.value.items.primary = heroTemp.items.primary.map(el => ({
        ...el,
        localId: Math.random().toString(),
        uploadingFile: false,
        file: null,
      }))
      formData.value.items.secondary = heroTemp.items.secondary.map(el => ({
        ...el,
        localId: Math.random().toString(),
        uploadingFile: false,
        file: null,
      }))
    }
    if (heroId) {
      fetchHeroById()
    }

    return {
      submitting,
      formRef,
      submit,
      pushNewPrimaryHero,
      removeSecondaryHero,
      pushNewSecondaryHero,
      required,
      primaryRef,
      removePrimaryHero,
      secondaryRef,
      formData,
      fileInputHandler,
      filesUploading,
    }
  },
}
</script>

  <style>

  </style>
